"use strict";

exports.__esModule = true;
exports.LogbookPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Theme = require("../Theme");
var _Core = require("../Core");
var _LogbookTicket = require("./LogbookItems/LogbookTicket");
var _constants = require("./constants");
var _LogbookComment = require("./LogbookItems/LogbookComment");
var _NewLogbookTicket = require("./NewLogbookTicket");
var _NewLogbookComment = require("./NewLogbookComment");
var _LogbookList = require("./LogbookList");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LogbookWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__LogbookWrapper",
  componentId: "sc-ar8y4w-0"
})(["border:1px solid ", ";background:", ";"], (0, _Theme.val)("LogbookBorderColor"), function (props) {
  return props.theme.LogbookBackground;
});
var LogbookHeader = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__LogbookHeader",
  componentId: "sc-ar8y4w-1"
})(["background:", ";display:flex;justify-content:space-between;align-items:center;padding:0 0.8rem;height:48px;"], (0, _Theme.val)("LogbookHeaderBackground"));
var LogbookListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__LogbookListWrapper",
  componentId: "sc-ar8y4w-2"
})(["padding:0 0 0.8rem;overflow-y:auto;height:calc( 100% - ", " - ", " );"], function (props) {
  return props.theme.LogbookHeaderHeight;
}, function (props) {
  return props.showFilterPanel ? props.theme.LogbookFiltersHeight : "0px";
});
var SearchWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__SearchWrapper",
  componentId: "sc-ar8y4w-3"
})([""]);
var CheckboxList = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__CheckboxList",
  componentId: "sc-ar8y4w-4"
})(["border-bottom:1px solid ", ";padding:0 0.8rem 0.8rem;"], (0, _Theme.val)("LogbookBorderColor"));
var SearchInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__SearchInputWrapper",
  componentId: "sc-ar8y4w-5"
})(["padding:0.8rem;"]);
var Left = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__Left",
  componentId: "sc-ar8y4w-6"
})(["display:flex;flex-direction:row;flex:0 0 90px;"]);
var Right = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__Right",
  componentId: "sc-ar8y4w-7"
})(["display:flex;flex-direction:row;justify-content:flex-end;"]);
var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookPanellegacy__ButtonWrapper",
  componentId: "sc-ar8y4w-8"
})(["display:flex;flex:0 0 40px;padding-left:0.3rem;"]);
var LogbookHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "LogbookPanellegacy__LogbookHeading",
  componentId: "sc-ar8y4w-9"
})(["padding:0;margin:0;"]);
var LogbookPanel = exports.LogbookPanel = /*#__PURE__*/function (_Component) {
  function LogbookPanel() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderItems = function (items) {
      var logbook = _this.props.logbook;
      return items.map(function (item) {
        switch (item.type) {
          case _constants.LOGBOOK_TICKET:
            return /*#__PURE__*/_react["default"].createElement(_LogbookTicket.LogbookTicket, {
              logbook: logbook,
              key: item.id,
              ticket: item
            });
          case _constants.LOGBOOK_COMMENT:
            return /*#__PURE__*/_react["default"].createElement(_LogbookComment.LogbookComment, {
              key: item.commentId,
              comment: item
            });
          default:
            return null;
        }
      });
    };
    _this.addTicket = function () {
      var logbook = _this.props.logbook;
      logbook.toggleAddTicketPanel();
    };
    _this.addComment = function () {
      var logbook = _this.props.logbook;
      logbook.toggleAddCommentPanel();
    };
    _this.closeNewEvent = function () {
      var logbook = _this.props.logbook;
      logbook.closeEventPanels();
    };
    _this.toggleFilters = function () {
      var logbook = _this.props.logbook;
      logbook.toggleFilterPanel();
    };
    _this.onCheckboxChange = function (itemType) {
      var logbook = _this.props.logbook;
      logbook.setSelectedItemTypes(itemType);
    };
    return _this;
  }
  _inheritsLoose(LogbookPanel, _Component);
  var _proto = LogbookPanel.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      logbook = _this$props.logbook,
      onClick = _this$props.onClick,
      reload = _this$props.reload;
    return /*#__PURE__*/_react["default"].createElement(LogbookWrapper, {
      onClickCapture: onClick,
      style: {
        width: width,
        height: height,
        overflowY: "hidden"
      }
    }, /*#__PURE__*/_react["default"].createElement(LogbookHeader, null, /*#__PURE__*/_react["default"].createElement(Left, null, /*#__PURE__*/_react["default"].createElement(LogbookHeading, {
      level: "3"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookPanel.title",
      defaultMessage: "Logbook"
    }))), /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: logbook.showFilterPanel,
      minimal: true,
      icon: _icons.IconNames.FILTER,
      onClick: this.toggleFilters
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookPanel.filters",
      defaultMessage: "Filters"
    }))))), !logbook.showNewTicket && !logbook.showNewComment && /*#__PURE__*/_react["default"].createElement(SearchWrapper, null, logbook.showFilterPanel && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SearchInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
      onChange: function onChange(searchTerm) {
        logbook.filterLogbookItems(searchTerm);
      },
      value: logbook.searchTerm
    })), /*#__PURE__*/_react["default"].createElement(CheckboxList, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: true,
      checked: logbook.selectedItemTypes.includes(_constants.LOGBOOK_TICKET),
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "LogbookPanel.ticketCheckbox",
        defaultMessage: "Show tickets"
      }),
      onChange: function onChange() {
        return _this2.onCheckboxChange(_constants.LOGBOOK_TICKET);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      inline: true,
      checked: logbook.selectedItemTypes.includes(_constants.LOGBOOK_COMMENT),
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "LogbookPanel.commentCheckbox",
        defaultMessage: "Show comments"
      }),
      onChange: function onChange() {
        return _this2.onCheckboxChange(_constants.LOGBOOK_COMMENT);
      }
    })))), /*#__PURE__*/_react["default"].createElement("div", null, logbook.showNewComment && /*#__PURE__*/_react["default"].createElement(_NewLogbookComment.NewLogbookComment, {
      logbook: logbook,
      closeNewEvent: this.closeNewEvent
    }), logbook.showNewTicket && /*#__PURE__*/_react["default"].createElement(_NewLogbookTicket.NewLogbookTicket, {
      logbook: logbook,
      closeNewEvent: this.closeNewEvent
    })), /*#__PURE__*/_react["default"].createElement(LogbookListWrapper, {
      showFilterPanel: logbook.showFilterPanel
    }, /*#__PURE__*/_react["default"].createElement(_LogbookList.LogbookList, {
      reload: reload
    }, this.renderItems(logbook.filteredLogbookItems))), /*#__PURE__*/_react["default"].createElement("button", {
      id: "logbook-reset-button-" + logbook.device.uuid,
      hidden: true,
      onClick: reload
    }));
  };
  return LogbookPanel;
}(_react.Component);